<template>
  <ElCard class="editor-card" shadow="never" ref="container" v-loading="loading"> </ElCard>
</template>

<script src="./index.js"></script>
<style lang="scss" src="./index.scss" />
<i18n src="./index.locales.json" />
